import Components from "slotworks/components/components";
import Contract from "slotworks/utils/contract";

export function StaticSymbolsCommand(): Contract<void> {
    Components.matrix.resetSymbols();

    return new Contract<void>((resolve) => { resolve(null); });
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/symbols/static-symbols-command.ts